import {useCallback, useState} from 'react';

/**
 * Custom hook for the `FaqBlock` component.
 * Manages which accordion item is currently expanded.
 *
 * @returns An object containing:
 * - `openId`: The ID of the currently open item, or `null`.
 * - `toggle`: Callback to toggle an item open/closed.
 */
export const useFaqBlock = () => {
    const [openId, setOpenId] = useState<string | null>(null);

    /**
     * Toggles the accordion item with the given ID.
     * If the item is already open, it closes it.
     *
     * @param id The ID of the item to toggle.
     */
    const toggle = useCallback((id: string) => {
        setOpenId(prev => (prev === id ? null : id));
    }, []);

    return {
        openId,
        toggle
    };
};